import React from 'react'
import "./particle.css"
const Particle = () => {
  return (
    <>
      <div class="bg"></div>
      <div class="bg bg2"></div>
      <div class="bg bg3"></div>
    </>
  )
}
export default Particle